import * as couponLikeTypes from "../types/couponLikeTypes";
import * as couponLikeServices from "../../services/couponLikeServices";
import { mergeCoupon } from "./couponActions";

export const addCouponLike = (couponPublicId) => async (dispatch) => {
  dispatch({
    type: couponLikeTypes.COUPON_LIKE_ADD_REQUEST,
    payload: { couponPublicId },
  });
  try {
    const data = await couponLikeServices.addLikedCoupon(couponPublicId);
    dispatch({
      type: couponLikeTypes.COUPON_LIKE_ADD_SUCCESS,
      payload: { couponPublicId, data },
    });
    if (data?.coupon) dispatch(mergeCoupon(data.coupon));
  } catch (e) {
    dispatch({
      type: couponLikeTypes.COUPON_LIKE_ADD_FAILURE,
      payload:
        e?.response?.data?.message || e?.message || "Could not save coupon",
    });
  }
};

export const removeCouponLike = (couponPublicId) => async (dispatch) => {
  dispatch({
    type: couponLikeTypes.COUPON_LIKE_REMOVE_REQUEST,
    payload: { couponPublicId },
  });
  try {
    const data = await couponLikeServices.removeLikedCoupon(couponPublicId);
    dispatch({
      type: couponLikeTypes.COUPON_LIKE_REMOVE_SUCCESS,
      payload: { couponPublicId, data },
    });
    if (data?.coupon) dispatch(mergeCoupon(data.coupon));
  } catch (e) {
    dispatch({
      type: couponLikeTypes.COUPON_LIKE_REMOVE_FAILURE,
      payload:
        e?.response?.data?.message || e?.message || "Could not remove save",
    });
  }
};
